<template>
	<div v-if="!isLoading">
		<div>
			<BaseHeader :title="$t('settings').toString()" />
			<div class="main">
				<div class="flex flex-col">
					<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
							<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" v-if="allowedFilterNotifications.length > 0">
								<table class="min-w-full divide-y divide-gray-200">
									<thead>
										<tr>
											<th class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
												{{ $t('setting') }}
											</th>
											<th class="w-32 px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
												{{ $t('bell') }}
											</th>
											<th class="w-32 px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
												{{ $t('e-mail') }}
											</th>
										</tr>
									</thead>
									<tbody class="bg-white divide-y divide-gray-200">
										<tr class="text-left" v-for="notification in allowedFilterNotifications" :key="notification.id">
											<td class="px-6 py-4">
												{{ getAccountSettingsNotificationName(notification.key) }}
											</td>
											<td class="px-6 py-4 text-left">
												<Toggle
													@click.native.prevent="save(notification, 'receive_bell')"
													v-if="checkDatabaseBlacklist(notification.key)"
													:active="checkBellNotificationStatus(notification)"
												/>
											</td>
											<td class="px-6 py-4 text-left">
												<Toggle
													@click.native.prevent="save(notification, 'receive_mail')"
													v-if="checkMailBlacklist(notification.key)"
													:active="checkMailNotificationStatus(notification)"
												/>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="font-bold my-6" v-else>
								{{ $t('no_settings_found') }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<LoadingSpinner v-else />
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import Validate from '@/mixins/Validate';
import RegexpHelper from '@/mixins/RegexpHelper';
import Authentication from '@/mixins/Authentication';
import LoadingSpinner from '@/components/navigation/LoadingSpinner.vue';
import UserNotificationSettingsRepository from '@/api/repositories/UserNotificationSettingsRepository';
import { getAccountSettingsNotificationName } from '@/helpers/Utils';
import Toggle from '@/components/forms/Toggle.vue';

export default {
	name: 'Userprofile',
	components: {
		LoadingSpinner,
		BaseHeader,
		Toggle
	},
	mixins: [Validate, RegexpHelper, Authentication, LoadingSpinner],
	data() {
		return {
			isLoading: true,
			disableButton: false,
			allowedFilterNotifications: [],
			userNotificationSettings: [],
		};
	},
	mounted() {
		this.isLoading = true;
		this.fetchUserSettings();
	},
	methods: {
		getAccountSettingsNotificationName,
		fetchUserSettings() {
			this.isLoading = true;
			new UserNotificationSettingsRepository()
				.getSettings()
				.then(response => {
					this.allowedFilterNotifications = response.data.allowedNotificationTypes;
					this.userNotificationSettings = response.data.userNotificationSettings;
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
				});
		},
		checkBellNotificationStatus(notification) {
			return this.userNotificationSettings[notification.key].receive_bell;
		},
		checkMailNotificationStatus(notification) {
			return this.userNotificationSettings[notification.key].receive_mail;
		},
		checkMailBlacklist(key) {
			switch (key) {
				case 'assigned_damage_assessor_to_repair_shop':
				case 'assigned_lawyer_office_to_repair_shop':
				case 'document_stored':
				case 'mandate_ended_early':
				case 'document_signed_by_customer':
					return false;
				default:
					return true;
			}
		},
		checkDatabaseBlacklist(key) {
			switch (key) {
				case 'new_customer_chat_message':
				case 'final_calculation_stored':
					return false;
				default:
					return true;
			}
		},
		save(notification, type) {
			this.isLoading = true;
			let state = false;
			if (type === 'receive_bell') {
				state = this.userNotificationSettings[notification.key].receive_bell = !this.userNotificationSettings[notification.key].receive_bell;
			} else {
				state = this.userNotificationSettings[notification.key].receive_mail = !this.userNotificationSettings[notification.key].receive_mail;
			}

			const request = { notification_id: notification.id, notification_key: notification.key, type: type, value: state };

			new UserNotificationSettingsRepository()
				.updateSettings(request)
				.then(response => {
					this.isLoading = false;
					this.$swal(this.$t('general.success').toString(), this.$t('general.changes_saved').toString(), 'success').then(_ => {
						this.fetchUserSettings();
					});
				})
				.catch(e => {
					console.log(e);
					this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
				});
		},
	},
};
</script>

<style scoped></style>
